"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorButtonDebug = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorButtonDebug = ({
  text = 'Re-open in Debug Mode'
}) => {
  const navigate = (0, _react.useCallback)(() => {
    const url = new URL(window.location.href);

    // Add ?dbg (no value) if not already present
    if (!url.searchParams.has('dbg')) {
      url.searchParams.append('dbg', '');
    }
    const finalUrl = url.toString();
    if (window.self === window.top) {
      window.location.href = finalUrl;
    } else {
      window.parent.location.href = finalUrl;
    }
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box
  // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
  , {
    sx: {
      justifyContent: 'center'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.StyledButton, {
      id: "ui-error-page-back-button",
      variant: "contained",
      color: "primary",
      onClick: navigate,
      children: [text, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
        title: `Reloads the current page with the Debug Mode active.
                  During the Debug Mode, all ASMS caches are skipped, and logs of all levels are saved into Application Insights.
                  All logs are available in the transaction trace, accessible via the link below. Info-level logs are presented as Traces upon clicking on the blue button "View all".`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircleFilled, {
          fontSize: "inherit"
        })
      })]
    })
  });
};
exports.ErrorButtonDebug = ErrorButtonDebug;
